import { COMPONENT_IDS } from "../storage2ComponentIDs";
export default class AdjustableDataComponent {
    constructor({ min, max }) {
        this.typeId = COMPONENT_IDS.ADJUSTABLE_COMPONENT;
        this.doStoreInSnapshot = true;
        this.min = 0;
        this.max = 0;
        this.serializable = false;
        this.min = min;
        this.max = max;
    }
    eq(_other) {
        return false;
    }
}
